import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 32722 31111"
    {...props}
  >
    <path
      d="M16363 13908zm0 0zm0 0zm0 0-256-358 256 358-817-7525L6644 529l2768 10342 6951 3037zm0 0zm0 0zm0 0 501 157-501-157 5029 5574 10698-465-8295-6557-7432 1448zm0 0zm257-358-257 358 6919-3112L26083 529l-8949 5874-771 7505 257-358zm-802 528 545-170-7444-1382-8283 6491 10699 465 5028-5574-545 170zm545 388v-558l-3697 6483 3697 10052 3713-10019-3713-6516v558z"
      style={{
        fill: "#000",
        stroke: "#fefefe",
        strokeWidth: 462.572,
      }}
      className="stroke1 fill"

    />
  </svg>
)
export default SvgComponent
